<template>
  <div v-if="map" class="map-pin-tool" />
</template>

<script>
import L from 'leaflet';

export default {
  name: 'MapPin',
  props: {
    map: { type: Object, required: true },
    pins: {
      type: Array,
      default: () => [],
      // Each pin: { lat: Number, lng: Number, title?: String, description?: String }
    },
    enabled: { type: Boolean, default: true },
  },
  watch: {
    pins: {
      handler() {
        if (this.enabled) {
          this.renderPins();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      markers: [],
    };
  },
  methods: {
    clearPins() {
      this.markers.forEach((m) => m.remove());
      this.markers = [];
    },
    renderPins() {
      this.clearPins();
      this.pins.forEach((pin) => {
        const marker = L.marker([pin.lat, pin.lng], {
          icon: this.getCustomIcon()
        });

        if (pin.title || pin.description) {
          marker.bindPopup(`<strong>${pin.title || ''}</strong><br>${pin.description || ''}`);
        }

        marker.addTo(this.map);
        this.markers.push(marker);
      });
    },
    getCustomIcon() {
      return L.icon({
        iconUrl: require('leaflet/dist/images/marker-icon.png'), // adjust path
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        shadowSize: [41, 41],
      });
    },
  },
};
</script>
